<template>
  <div id='pins'>
    <Results type='mypins'/>
  </div>
</template>
<script>

import Results from './components/Results.vue'

export default {
  name: 'Profile',
  components: {
    Results,
  },
}

</script>
<style>
#pins{
  height: 100%;
}
</style>
